@if (onboarding.welkomOpen()) {
  <div class="welkom-scherm">
    <div class="welkom" role="dialog" aria-modal="true" aria-labelledby="welkomTitel">
      <div class="voortgang" aria-hidden="true">
        @for (s of stappen; track s; let i = $index) {
          <i [class.aan]="i <= index()"></i>
        }
      </div>
      <div class="stapje">{{ 'ONBOARDING.welkom.stap' | translate: { nr: index() + 1, totaal: stappen.length } }}</div>

      @switch (stap()) {
        @case ('profiel') {
          <h2 id="welkomTitel" class="titel">{{ 'ONBOARDING.welkom.profiel_vraag' | translate }}</h2>
          <div class="uitleg">{{ 'ONBOARDING.welkom.profiel_uitleg' | translate }}</div>
          <div class="keuzes" role="radiogroup" aria-labelledby="welkomTitel">
            @for (p of profielen(); track p) {
              <button type="button" class="keuze" role="radio"
                      [class.aan]="profiel() === p" [attr.aria-checked]="profiel() === p"
                      (click)="kiesProfiel(p)">
                <span class="vink" aria-hidden="true"></span>
                <span class="keuze-titel">{{ 'ONBOARDING.profielen.' + p + '.naam' | translate }}</span>
                <span class="keuze-uitleg">{{ 'ONBOARDING.profielen.' + p + '.uitleg' | translate }}</span>
              </button>
            }
          </div>
        }
        @case ('doelen') {
          <h2 id="welkomTitel" class="titel">{{ 'ONBOARDING.welkom.doelen_vraag' | translate }}</h2>
          <div class="uitleg">{{ 'ONBOARDING.welkom.doelen_uitleg' | translate }}</div>
          <div class="keuzes" role="group" aria-labelledby="welkomTitel">
            @for (d of alleDoelen; track d) {
              <button type="button" class="keuze" role="checkbox"
                      [class.aan]="doelen().includes(d)" [attr.aria-checked]="doelen().includes(d)"
                      (click)="wisselDoel(d)">
                <span class="vink" aria-hidden="true"></span>
                <span class="keuze-titel">{{ 'ONBOARDING.doelen.' + d | translate }}</span>
              </button>
            }
          </div>
        }
        @case ('team') {
          <h2 id="welkomTitel" class="titel">{{ 'ONBOARDING.welkom.team_vraag' | translate }}</h2>
          <div class="uitleg">{{ 'ONBOARDING.welkom.team_uitleg' | translate }}</div>
          <div class="keuzes" role="radiogroup" aria-labelledby="welkomTitel">
            @for (p of ploegen(); track p.sleutel) {
              <button type="button" class="keuze" role="radio"
                      [class.aan]="team() === p.sleutel" [attr.aria-checked]="team() === p.sleutel"
                      (click)="kiesTeam(p.sleutel)">
                <span class="vink" aria-hidden="true"></span>
                <span class="keuze-titel">{{ p.naam }}</span>
              </button>
            }
          </div>
        }
      }

      <div class="voet">
        <button type="button" class="knop-tekst" [disabled]="bezig()" (click)="onOverslaan()">
          {{ 'ONBOARDING.welkom.overslaan' | translate }}
        </button>
        <div class="rechts">
          @if (index() > 0) {
            <button type="button" class="knop-tekst" [disabled]="bezig()" (click)="onTerug()">
              {{ 'ONBOARDING.welkom.terug' | translate }}
            </button>
          }
          <button type="button" class="knop-groen" [disabled]="!magVerder() || bezig()" (click)="onVolgende()">
            {{ (laatste() ? 'ONBOARDING.welkom.afronden' : 'ONBOARDING.welkom.volgende') | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
}
